export const handleOnlyDgit = (e: any) => {
  const inputValue = e.data;
  const newValue = inputValue.toUpperCase(); // Change the value to uppercase

  // Check if the input value contains any non-numeric characters
  if (!/^\d/.test(newValue)) {
    e.preventDefault(); // Prevent the update
    return;
  }
};
